import { render, staticRenderFns } from "./sdParseList.vue?vue&type=template&id=3c3c0b90&scoped=true"
import script from "./sdParseList.vue?vue&type=script&lang=js"
export * from "./sdParseList.vue?vue&type=script&lang=js"
import style0 from "./sdParseList.vue?vue&type=style&index=0&id=3c3c0b90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3c0b90",
  null
  
)

export default component.exports